import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemMediaComponent } from './item-media.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [ItemMediaComponent],
  imports: [CommonModule, SplitButtonModule, ButtonModule, TooltipModule],
  exports: [ItemMediaComponent],
})
export class ItemMediaModule {}
